import { render, staticRenderFns } from "./Prayer.vue?vue&type=template&id=5c0fa89f&scoped=true&"
import script from "./Prayer.vue?vue&type=script&lang=js&"
export * from "./Prayer.vue?vue&type=script&lang=js&"
import style0 from "./Prayer.vue?vue&type=style&index=0&id=5c0fa89f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0fa89f",
  null
  
)

export default component.exports